import styled from '@emotion/styled'
import AutosizeInput from 'react-input-autosize'

export const SSubtleInput = styled(AutosizeInput)`
  overflow: hidden;
  & input {
    border: none;
    outline: none;
    font-family: var(--f-text);
    font-style: normal;
    font-size: 1rem;
    line-height: 1.6875;
    margin: 0;
    padding: 0;
    max-width: 100%;
    text-overflow: ellipsis;
    padding: 2px;
  }
`
